/**
 * Vantage Core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface ProcedureCodeDetailsIntegrationViewModel {
  /**
   * Procedure Code Id (not used for Add)
   */
  id?: string | null;
  /**
   * Dataset Id (not used for Add)
   */
  datasetId?: string;
  /**
   * Procedure Code, max length 20
   */
  code?: string | null;
  /**
   * Procedure Description, max length 500
   */
  description?: string | null;
  /**
   * Procedure Amount, defaults to 0
   */
  amount?: string | null;
  /**
   * Service Type, defaults to blank. Accepted values are Medical Care, Surgery, Consultation, Diagnostic X-Ray, Diagnostic Laboratory, Radiation Therapy, Anesthesia, Assistance At Surgery, Other Medical Services, Supplies, Drugs
   */
  serviceType?: string | null;
  /**
   * Reporting Type, must be a valid reporting type
   */
  procedureReportingType?: string | null;
  /**
   * Reporting Type Id (not used for Add)
   */
  reportingTypeId?: string | null;
  /**
   * Procedure RVU type. Valid values are Facility or Non Facility
   */
  procedureRVUType?: string | null;
  /**
   * Option to classify procedure as a Not Otherwise Classified (NOC) charge
   */
  nocProcedure?: string | null;
  /**
   * Default procedure code to bill
   */
  insuranceCode1?: string | null;
  /**
   * Alternate procedure code to bill for selected insurances
   */
  insuranceCode2?: string | null;
  /**
   * Alternate procedure code to bill for selected insurances
   */
  insuranceCode3?: string | null;
  /**
   * Alternate procedure code to bill for selected insurances
   */
  insuranceCode4?: string | null;
  /**
   * Alternate procedure code to bill for selected insurances
   */
  insuranceCode5?: string | null;
  /**
   * Option to inactivate procedure
   */
  procedureInactive?: string | null;
  /**
   * Option to send the service location\'s CLIA number on claim
   */
  procedureSendClia?: string | null;
  /**
   * Option to send service location\'s mammography certificate number on claim
   */
  procedureSendMammo?: string | null;
  /**
   * Primary default modifier for procedure
   */
  procedureDefaultModifier1?: string | null;
  /**
   * Primary default modifier id (not used for add)
   */
  defaultModifier1Id?: string | null;
  /**
   * Secondary default modifier for procedure
   */
  procedureDefaultModifier2?: string | null;
  /**
   * Secondary default modifier id (not used for Add)
   */
  defaultModifier2Id?: string | null;
  /**
   * Tertiary default modifier for procedure
   */
  procedureDefaultModifier3?: string | null;
  /**
   * Tertiary default modifier id (not used for Add)
   */
  defaultModifier3Id?: string | null;
  /**
   * Fourth default modifier for procedure
   */
  procedureDefaultModifier4?: string | null;
  /**
   * Fourth default modifier Id (not used for Add)
   */
  defaultModifier4Id?: string | null;
  /**
   * Option to default new procedure transactions to Hold Insurance Billing
   */
  procedureDefaultHoldBilling?: string | null;
}
